import type { NestedHome } from '@habity/types';
import { shouldShowPrice } from '@habity/services';

export const hasPrice = (home: NestedHome) => {
  const { price, price_type, estimate } = home || {};
  
  if (!shouldShowPrice(home)) {
    return false;
  }
  
  if (price_type === 'broker-valuation') return price && price > 0;
  return estimate && estimate > 0;
};
